import { render, staticRenderFns } from "./priceCollect_add.vue?vue&type=template&id=39f8db87&scoped=true&"
import script from "./priceCollect_add.vue?vue&type=script&lang=js&"
export * from "./priceCollect_add.vue?vue&type=script&lang=js&"
import style1 from "./priceCollect_add.vue?vue&type=style&index=1&id=39f8db87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8db87",
  null
  
)

export default component.exports